"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPropertyDto = instanceOfPropertyDto;
exports.PropertyDtoFromJSON = PropertyDtoFromJSON;
exports.PropertyDtoFromJSONTyped = PropertyDtoFromJSONTyped;
exports.PropertyDtoToJSON = PropertyDtoToJSON;
exports.PropertyDtoToJSONTyped = PropertyDtoToJSONTyped;
/**
 * Check if a given object implements the PropertyDto interface.
 */
function instanceOfPropertyDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
function PropertyDtoFromJSON(json) {
    return PropertyDtoFromJSONTyped(json, false);
}
function PropertyDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'location': json['location'] == null ? undefined : json['location'],
        'media': json['media'] == null ? undefined : json['media'],
    };
}
function PropertyDtoToJSON(json) {
    return PropertyDtoToJSONTyped(json, false);
}
function PropertyDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'title': value['title'],
        'location': value['location'],
        'media': value['media'],
    };
}
